import { ElMessage } from "element-plus";

export default {
    mounted(el, binding) {
        el.copyValue = binding.value;

        const showSuccessMessage = ()=>{
            ElMessage.success({
                message: '复制成功',
                duration: 1500
            });
        }

        const promptManualCopy = (text)=> {
            // 创建临时输入框让用户手动复制
            const tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            
            // 显示提示信息
            ElMessage.warning({
                message: '请按 Ctrl+C 复制内容',
                duration: 3000
            });
            
            // 3秒后移除输入框
            setTimeout(() => {
                document.body.removeChild(tempInput);
            }, 3000);
        }

        const useFallbackMethod = (text)=>{
            try {
                // 创建隐藏的 textarea
                const textArea = document.createElement('textarea');
                textArea.value = text;
                textArea.style.position = 'fixed';
                textArea.style.top = '0';
                textArea.style.left = '0';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                
                // 选择文本
                textArea.select();
                textArea.setSelectionRange(0, textArea.value.length);
                
                // 尝试复制
                const success = document.execCommand('copy');
                document.body.removeChild(textArea);
                
                if (success) {
                    showSuccessMessage();
                } else {
                    throw new Error('execCommand 复制失败');
                }
            } catch (err) {
                console.error('回退方法错误:', err);
                promptManualCopy(text);
            }
        }
        
        const copyText = () => {
            if (!el.copyValue) return;
            
            // 1. 尝试使用现代 Clipboard API
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(el.copyValue)
                    .then(() => {
                        showSuccessMessage();
                    })
                    .catch(err => {
                        console.error('Clipboard API 错误:', err);
                        useFallbackMethod(el.copyValue);
                    });
            } 
            // 2. 如果不支持或不在安全上下文中，使用回退方案
            else {
                useFallbackMethod(el.copyValue);
            }
        };
        
        el.copyHandler = copyText;
        el.addEventListener('click', el.copyHandler);
        el.style.cursor = 'pointer';
    },
    
    updated(el, binding) {
        el.copyValue = binding.value;
    },
    
    unmounted(el) {
        el.removeEventListener('click', el.copyHandler);
    }
};